
import { LIST_USERS, CREATE_USER,USER_CLIENTS, END_URL, VALIDATION } from './config';
// import _ from 'lodash';
import { closeDialog } from '../../lib/redux-reactstrap-modal';
import { API_URL, TYPE,urlParam } from '../../config/globals';
import axios from 'axios';
import Toast from './../../config/toast'
import {loaderActions  } from '../common/action';
axios.defaults.baseURL = API_URL;

axios.interceptors.request.use(
    function (config) {       
      const token = JSON.parse(localStorage.getItem("auth")) ? JSON.parse(localStorage.getItem("auth")).token : null;
      if (token) {
        config.headers["authorization"] = token;
      }
  
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

export const getUsers = (id) => {
    return (dispatch, getState) => {
        dispatch(loaderActions(true))
        const url = id ? `${END_URL.USERS}?id=${id}` : `${END_URL.USERS}`;
        axios.get(url).then(function (response) {
            if (response.status) {
                dispatch(
                    {
                        type: LIST_USERS,
                        payload: response.data
                    });
                    dispatch(loaderActions(false))
            }
        }).catch(err => {
           
            const msg = (err.response && err.response.data) ?
                err.response.data.message : VALIDATION.SYSTEM_ERROR
            Toast(msg, TYPE.ERROR)
            dispatch(loaderActions(false))
        });
    };
}
export const getUserById = (id) => {
    return (dispatch, getState) => {
        dispatch(loaderActions(true))
        const url = id ? `${END_URL.USER}?id=${id}` : `${END_URL.USER}`;
        axios.get(url).then(function (response) {
            if (response.status) {
                dispatch(
                    {
                        type: LIST_USERS,
                        payload: response.data
                    });
                    dispatch(loaderActions(false))
            }
        }).catch(err => {

            const msg = (err.response && err.response.data) ?
                err.response.data.message : VALIDATION.SYSTEM_ERROR
            Toast(msg, TYPE.ERROR)
            dispatch(loaderActions(false))
        });
    };
}

export const createUser = (data, redirect) => {
    return (dispatch, getState) => {
        dispatch(loaderActions(true))
        axios.post(END_URL.CREATE, data
        ).then(function (response) {
            if (response.status) {
               
                Toast(TYPE.SUCCESS, TYPE.SUCCESS)
                // redirect();
                dispatch(
                    {
                        type: CREATE_USER,
                        payload: response.data
                        // payload : {data:{id:1}}
                    });
                    dispatch(loaderActions(false))
            }

        }).catch(err => {

            const msg = (err.response && err.response.data) ?
                err.response.data.message : VALIDATION.SYSTEM_ERROR
            Toast(msg, TYPE.ERROR)
            dispatch(loaderActions(false))
        });
    };
}

export const updateUser =  (data, redirect) => {
    return (dispatch, getState) => {
        dispatch(loaderActions(true))
        axios.put(END_URL.UPDATE, data).then(function (response) {
            if (response.status) {
                console.log("response--->", response)
                Toast(TYPE.SUCCESS, TYPE.SUCCESS)
                dispatch(getUsers());
                redirect && redirect();
                dispatch(loaderActions(false))
            }

        }).catch(err => {
             
            const msg = (err.response && err.response.data) ?
                err.response.data.message : VALIDATION.SYSTEM_ERROR
            Toast(msg, TYPE.ERROR)
            dispatch(loaderActions(false))
        });
    };
}

export const updatePermission = (data, redirect) => {
    return (dispatch, getState) => {
        dispatch(loaderActions(true))
        axios.post(END_URL.PERMISSION_UPDATE, data).then(function (response) {
            if (response.status) {               
                Toast(TYPE.SUCCESS, TYPE.SUCCESS)
                dispatch(getUsers());
                
                dispatch(closeDialog('MODAL_PERMISSION'))
                redirect && redirect();
                dispatch(loaderActions(false))
            }

        }).catch(err => {
       
            const msg = (err.response && err.response.data) ?
                err.response.data.message : VALIDATION.SYSTEM_ERROR
            Toast(msg, TYPE.ERROR)
            dispatch(loaderActions(false))
        });
    };
}


export const getUserClients = (data) => {
    return (dispatch, getState) => { 
        dispatch(loaderActions(true))
        const url = data ? `${END_URL.USER_CLIENTS}?${urlParam(data)}` : `${END_URL.USER_CLIENTS}`;
        axios.get(url).then(function (response) {
            if (response.status) {
                dispatch(
                    {
                        type: USER_CLIENTS,
                        payload: response.data
                    });
                    dispatch(loaderActions(false))
            }
        }).catch(err => {
           
            const msg = (err.response && err.response.data) ?
                err.response.data.message : VALIDATION.SYSTEM_ERROR
            Toast(msg, TYPE.ERROR)
            dispatch(loaderActions(false))
        });
    };
}